import { useState } from 'react';
import './PublishModal.css';

export default function PublishModal({ isOpen, healthScore, nextVersionNumber, onPublish, onClose, isPublishing }) {
  const [tag, setTag] = useState('');
  const [summary, setSummary] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  const handlePublish = async () => {
    try {
      await onPublish({
        version_tag: tag || `v${nextVersionNumber}`,
        change_summary: summary
      });
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
        setTag('');
        setSummary('');
        onClose();
      }, 1500);
    } catch (err) {
      alert('Failed to publish: ' + err.message);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="publish-overlay" onClick={onClose}>
      <div className="publish-modal" onClick={e => e.stopPropagation()}>
        {!showSuccess ? (
          <>
            <div className="publish-modal__icon">&#128640;</div>
            <div className="publish-modal__title">Ready to Publish?</div>
            <div className="publish-modal__subtitle">Create an immutable snapshot of your pipeline configuration</div>

            <div className="publish-modal__version-label">Publishing as Version</div>
            <div className="publish-modal__version-num">v{nextVersionNumber}</div>

            {healthScore < 60 && (
              <div className="publish-modal__warning">
                &#9888;&#65039; Your pipeline health is {healthScore}%. Consider adding more checklist items to stages.
              </div>
            )}

            <div className="publish-modal__field">
              <label className="publish-modal__label">Version Tag (optional)</label>
              <input
                type="text"
                className="publish-modal__input"
                value={tag}
                onChange={e => setTag(e.target.value)}
                placeholder={`v${nextVersionNumber} - e.g., Q1 Config`}
              />
            </div>

            <div className="publish-modal__field">
              <label className="publish-modal__label">Change Summary (optional)</label>
              <textarea
                className="publish-modal__textarea"
                value={summary}
                onChange={e => setSummary(e.target.value)}
                placeholder="Describe the changes in this version..."
              />
            </div>

            <div className="publish-modal__buttons">
              <button className="btn btn--outline" onClick={onClose} disabled={isPublishing}>Cancel</button>
              <button
                className={`btn ${isPublishing ? 'btn--disabled' : 'btn--primary'}`}
                onClick={handlePublish}
                disabled={isPublishing}
              >
                {isPublishing ? 'Publishing...' : 'Publish & Lock'}
              </button>
            </div>
          </>
        ) : (
          <div className="publish-modal__success">
            <div className="publish-modal__success-icon">&#10003;</div>
            <div className="publish-modal__title">Version Published!</div>
          </div>
        )}
      </div>
    </div>
  );
}
